import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import api, { getImageUrl } from '../services/api';
import { useSettings } from '../context/SettingsContext';

function BeforeAfterPage() {
  const { settings } = useSettings();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('');

  useEffect(() => {
    api.get('/before-after')
      .then(res => setItems(Array.isArray(res.data) ? res.data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const categories = [...new Set(items.filter(i => i.category).map(i => i.category))];
  const filtered = activeCategory
    ? items.filter(i => i.category === activeCategory)
    : items;

  return (
    <>
      <Helmet>
        <title>Öncesi / Sonrası | {settings.site_title || ''}</title>
      </Helmet>

      <div className="page-header">
        <div className="container">
          <h1>Öncesi / Sonrası</h1>
          <div className="breadcrumb">
            <Link to="/">Ana Sayfa</Link>
            <span>/</span>
            <span>Öncesi / Sonrası</span>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container">
          {categories.length > 0 && (
            <div className="blog-filters">
              <button
                className={`blog-filter-btn${activeCategory === '' ? ' active' : ''}`}
                onClick={() => setActiveCategory('')}
              >
                Tümü
              </button>
              {categories.map(cat => (
                <button
                  key={cat}
                  className={`blog-filter-btn${activeCategory === cat ? ' active' : ''}`}
                  onClick={() => setActiveCategory(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
          )}

          {loading ? (
            <p style={{ textAlign: 'center', padding: '2rem 0', color: '#888' }}>Yükleniyor...</p>
          ) : filtered.length === 0 ? (
            <p style={{ textAlign: 'center', padding: '2rem 0', color: '#888' }}>Henüz proje eklenmemiş.</p>
          ) : (
            <div className="before-after-projects-grid">
              {filtered.map(item => (
                <ProjectCard key={item.id} project={item} />
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}

function ProjectCard({ project }) {
  const cover = project.images?.[0]?.after_image;
  const pairCount = project.images?.length || 0;
  const target = project.slug ? `/oncesi-sonrasi/${project.slug}` : '#';

  return (
    <Link to={target} className="ba-project-card">
      <div className="ba-project-card-image">
        {cover ? (
          <img src={getImageUrl(cover)} alt={project.title} loading="lazy" />
        ) : (
          <div className="ba-project-card-placeholder">Görsel yok</div>
        )}
        {pairCount > 1 && (
          <span className="ba-project-card-badge">{pairCount} görsel</span>
        )}
      </div>
      <div className="ba-project-card-body">
        <h3>{project.title}</h3>
        {project.category && <span className="ba-project-card-category">{project.category}</span>}
        {project.description && <p>{project.description}</p>}
        <span className="ba-project-card-cta">İncele →</span>
      </div>
    </Link>
  );
}

export default BeforeAfterPage;
